import { ReferentialKey } from "api/referential";
import { mapReferentialsToDropdownItems } from "features/referentials/mappers/referentialMapper";
import { referentialsApi } from "services/swagger-api";
import { referentialCacheService } from "../../services/referentialCacheService";
import { ReferentialSyncActions } from "../types";

export const fetchReferentialByKey = async (
  referentialKey: ReferentialKey,
  actions: ReferentialSyncActions,
): Promise<void> => {
  try {
    actions.setLoading(true);
    actions.setError(null);

    // Vérifier d'abord le cache pour ce référentiel spécifique
    if (referentialCacheService.isReferentialCached(referentialKey)) {
      const cachedReferential = referentialCacheService.getSingleReferentialFromCache(referentialKey);

      if (cachedReferential) {
        actions.setSingleItem({
          referentialKey,
          referential: cachedReferential.referential,
          dropdownItem: cachedReferential.dropdownItem
        });
        actions.setLoading(false);
        return;
      }
    }

    // Si pas en cache, charger depuis l'API
    const response = await referentialsApi.getReferentialsByKey({ referentialKey });

    if (response && response.referential) {
      const dropdownItems = mapReferentialsToDropdownItems(response.referential);

      actions.setSingleItem({
        referentialKey,
        referential: response.referential,
        dropdownItem: dropdownItems
      });

      // Sauvegarder dans le cache
      referentialCacheService.saveSingleReferentialToCache(
        referentialKey,
        response.referential,
        dropdownItems
      );
      console.log(`Référentiel ${referentialKey} sauvegardé dans le cache`);
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : 'Une erreur est survenue');
  } finally {
    actions.setLoading(false);
  }
};
